import React, { ComponentType, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { PersonTableRow, TableFriendlyName, updateUserRolesBulkDTO } from '../../store/info/types';
import { AppState } from '../../store/state';
import { AppDispatch } from '../../store/store';
import tableSlice, { getInitialDataState } from '../../store/table/slice';
import LabelDialog, { DialogMode, LabelDialogFields } from '../dialogs/LabelDialog/LabelDialog';
import MyGridCore from '../MyGridCore/MyGridCore';
import { gridSettingsProps } from '../MyGridCore/types';
import { TableSettings } from './types';
import { Label } from '../../store/label/types';
import labelSlice from '../../store/label/slice';
import { EmailRecipientType } from '../../store/email/types';
import ManageLabels from '../ManageLabels/ManageLabels';
import { downloadFile, downloadWithIds, getHref } from '../../helpers/download';
import MUIButton from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import LabelPicker from '../LabelPicker/LabelPicker';
import { intersection, union } from '../../helpers/set';
import { GridCellProps, GridColumnProps, GridDetailRowProps, GridFilterCellProps } from '@progress/kendo-react-grid';
import LabelsCell from '../MyGridCore/LabelsCell';
import {
  selectCurrentTrack,
  selectCurrentUser,
  selectFormState,
  selectLabelState,
  selectTable,
  selectKeywordState,
  selectTrackRoles,
  selectCurrentRole,
  selectKeywordsLevels,
  selectScreenState,
  selectRoleRelations,
} from '../../store/selectors';
import { OpenSnackBarDTO } from '../../store/error/types';
import errorSlice from '../../store/error/slice';
import IdCell from '../IdCell/IdCell';
import { Role, Track } from '../../store/conference/types';
import { getRouteByName } from '../../router/routes';
import { fillRoutePath } from '../../helpers/path';
import { Answer, Form, FormType, Question, QuestionType } from '../../store/form/types';
import { toKendoGridValue } from '../../helpers/form';
import QuestionCell from '../QuestionCell/QuestionCell';
import {
  CustomColumn,
  CustomColumnsUpdate,
  FilterBox,
  TableSaveAsSettingsDTO,
  TableDeleteSettingsDTO,
  TableFilterBoxChangeDTO,
  TablePatchSettingsDTO,
  TableSwitchFilterDTO,
  TableColumnId,
  Notifiable,
  NotifyDTO,
  aggregateColumnTabOption,
  LoadSettingsDTO,
  FilteredIdsUpdateDTO,
  FilterIdsKey,
  ExportDTO,
} from '../../store/table/types';
import { ImpersonateRequest, InvitationStatus } from '../../store/auth/types';
import authSlice from '../../store/auth/slice';
import PaperStatusChangeDialog from '../dialogs/PaperStatusChangeDialog/PaperStatusChangeDialog';
import RolesDialog from '../dialogs/RolesDialog/RolesDialog';
import infoSlice from '../../store/info/slice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faTags } from '@fortawesome/free-solid-svg-icons';
import history from '../../store/history';
import ActionsKmenu from '../ActionsKmenu/ActionsKmenu';
import ColumnSelectionDialog from '../dialogs/ColumnSelectionDialog/ColumnSelectionDialog';
import ExportTableDialog from '../dialogs/ExportTableDialog/ExportTableDialog';
import FileUploadCell from '../FileUploadCell/FileUploadCell';
import styled, { ThemeProvider } from 'styled-components';
import SimpleDialog from '../dialogs/SimpleDialog/SimpleDialog';
import recruitmentSlice from '../../store/recruitment/slice';
import { getter } from '@progress/kendo-react-common';
import BodyCell from '../BodyCell/BodyCell';
import { Invitation, RespondInvitationDTO } from '../../store/recruitment/types';
import RespondInvitationDialog from '../dialogs/RespondInvitationDialog/RespondInvitationDialog';
import AddPersonDialog from '../dialogs/AddPersonDialog/AddPersonDialog';
import { Action, actionOption, RowAction } from '../types';
import KeywordsCell from '../KeywordsCell/KeywordsCell';
import { Submission } from '../../store/submission/types';
import DownloadSubmissionsDialog from '../dialogs/DownloadSubmissionsDialog/DownloadSubmissionsDialog';
import { MultiSelectFilterCell } from '../MultiSelectFilterCell/MultiSelectFilterCell';
import AggregateColumnDialog from '../dialogs/AggregateColumnDialog/AggregateColumnDialog';
import { Kmenu } from '../ui/navigation/Kmenu/Kmenu';
import { faEye, faDatabase, faSync, faTableColumns } from '@fortawesome/free-solid-svg-icons';
import { MenuItem as KMenuItem } from '@progress/kendo-react-layout';
import SaveTableSettingsDialog from '../dialogs/SaveTableSettingsDialog/SaveTableSettingsDialog';
import useTheme from '@material-ui/core/styles/useTheme';
import TitleCell from '../TitleCell/TitleCell';
import { getCompositeAnswerId } from '../../helpers/answers';
import ChairDeleteSubmissionDialog from '../dialogs/ChairDeleteSubmissionDialog/ChairDeleteSubmissionDialog';
import { isCustomColumn, isQuestionColumn } from '../../helpers/table';
import SendEmailDialog from '../dialogs/SendEmailDialog/SendEmailDialog';
import { useTranslation } from 'react-i18next';
import { getTableColumnName, getTableViewName } from '../../helpers/translations';
import Download2 from '../../icons/Download2';
import Email2 from '../../icons/Email2';
import AssignedCell from '../AssignedCell/AssignedCell';
import AbstractCell from '../AbstractCell/AbstractCell';
import { Tooltip } from '@material-ui/core';
import { useWindowSize } from '../../helpers/window';
import { doesHandleReviewers } from '../../helpers/role';
import { can, SubmissionPermissionManager } from '../../helpers/permissions';
import FilterOutlined from '../../icons/FilterOutlined';
import { State } from '@progress/kendo-data-query';
import ChevronDownIcon from '../ui/icons/ChevronDown';
import ViewNewIcon from '../../icons/ViewNew';
import HiddenIcon from '../../icons/Hidden';
import FiltersManager from '../FiltersManager/FiltersManager';
import { FilterDescriptor } from '@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface';
import { HowItWorksButton } from '../ui/inputs/HowItWorksButton/HowItWorksButton';
import InvitationDialog from '../dialogs/InvitationDialog/InvitationDialog';
import { DeleteAssignment } from '../../store/review/types';
import assignmentSlice from '../../store/review/slice';
import DeleteAssignmentDialog from '../dialogs/DeleteAssignmentDialog/DeleteAssignmentDialog';
import PaperStatusLabel from '../PaperStatusLabel/PaperStatusLabel';
import { User } from '../../store/user/types';
import DateFilterCell from '../DateFilterCell/DateFilterCell';
import ConflictCell from '../ConflictCell/ConflictCell';
import InvitationBodyDialog from '../dialogs/InvitationBodyDialog/InvitationBodyDialog';
import CreateSubsetBidDialog from '../dialogs/CreateSubsetBidDialog/CreateSubsetBidDialog';
import { getPaperStatusCategory, getPaperStatusName } from '../../helpers/submission';
import IdFilterCell from '../IdFilterCell/IdFilterCell';

export const LabelDefaultColors = {
  backgroundColor: '#E0E0E0',
  textColor: '#232323',
};

export const DEFAULT_FONT_SIZE = 14;

interface Props {
  inputData: Record<string, unknown>[];
  friendlyName: TableFriendlyName;
  tablesSettings: { [key: string]: TableSettings };
  otherTablesSettings: { [key: string]: TableSettings[] };
  setGridSettingsAction: (data: TablePatchSettingsDTO) => void;
  saveSettingsAction: (friendlyName: TableFriendlyName) => void;
  saveAsSettingsAction: (data: TableSaveAsSettingsDTO) => void;
  loadSettingsAction: (data: LoadSettingsDTO) => void;
  deleteSettingsAction: (data: TableDeleteSettingsDTO) => void;
  pickLabelAction: (labelsByRowId: { [key: number]: number[] }, tableFriendlyName: TableFriendlyName) => void;
  unpickLabelAction: (recordId: number, labelId: number, tableFriendlyName: TableFriendlyName) => void;
  currentTrack: Track | null;
  createLabelAction: (
    data: LabelDialogFields,
    tableFriendlyName: TableFriendlyName,
    currentTrackId: number,
    rowIds?: number[],
  ) => void;
  updateLabelAction: (labelId: number, data: LabelDialogFields) => void;
  deleteLabelAction: (labelId: number, tableFriendlyName: TableFriendlyName) => void;
  getInfoAction?: () => void;
  getCustomColumnsData?: () => void;
  labelsById: { [key: number]: Label };
  labelables: { [key: string]: { [key: number]: number[] } };
  openSnackBarAction: (data: OpenSnackBarDTO) => void;
  questionById: { [key: number]: Question };
  answerById: { [key: string]: Answer };
  formById: { [key: number]: Form };
  filterBoxChangeAction: (data: TableFilterBoxChangeDTO) => void;
  switchFilterAction: (data: TableSwitchFilterDTO) => void;
  impersonateAction: (data: ImpersonateRequest) => void;
  updateUserRolesBulkAction: (data: updateUserRolesBulkDTO) => void;
  initRowActions?: { [key: string]: RowAction[] };
  dateFormat: string | null;
  clearValidationErrorsAction: () => void;
  deleteInvitationsAction: (ids: number[]) => void;
  updateSelectionAction: (data: number[], tableFriendlyName: TableFriendlyName) => void;
  clearSelectionAction: () => void;
  respondInvitationAction: (data: RespondInvitationDTO) => void;
  action: actionOption;
  setTableAction: (actionOpt: actionOption) => void;
  detail?: React.ComponentType<GridDetailRowProps> | null;
  selectable?: boolean;
  keywordById: { [key: number]: Keyword };
  customColumnsData: { [key: string]: { [key: number]: { [key: string]: any } } };
  customColumnsById: { [key: string]: CustomColumn };
  initialSelectedRowIds: { [key in TableFriendlyName]: number[] };
  updateCustomColumnsAction: (data: CustomColumnsUpdate) => void;
  notifiableIds: {
    [id: number]: Notifiable;
  };
  updateAssignmentAction?: (id: number, assigned: boolean, assignmentId: number, skipConflicts?: boolean) => void;
  notifyAction: (data: NotifyDTO) => void;
  roleById: { [key: string]: Role };
  gridForms: { [key: string]: { [key: string]: FormType[] } };
  deleteAssignmentAction: (data: DeleteAssignment) => void;
  filteredIds: { [key in FilterIdsKey]: number[] | undefined };
  updateFilteredIdsAction: (data: FilteredIdsUpdateDTO) => void;
  currentRole: Role | null;
  user: User;
  keywordsLevels: KeywordsLevels;
  resetExternalChangeCountAction: (data: TableFriendlyName) => void;
  screenByName: { Discussion: Screen; 'Subset Bidding': { [key: number]: Screen } };
  emailRoleIds: number[];
}

const MyGridRedux: React.FC<Props> = ({
  inputData,
  friendlyName,
  tablesSettings,
  otherTablesSettings,
  setGridSettingsAction,
  saveSettingsAction,
  saveAsSettingsAction,
  loadSettingsAction,
  deleteSettingsAction,
  pickLabelAction,
  unpickLabelAction,
  currentTrack,
  createLabelAction,
  updateLabelAction,
  deleteLabelAction,
  getInfoAction,
  getCustomColumnsData,
  labelsById,
  labelables,
  openSnackBarAction,
  questionById,
  answerById,
  formById,
  filterBoxChangeAction,
  switchFilterAction,
  impersonateAction,
  updateUserRolesBulkAction,
  initRowActions,
  dateFormat,
  clearValidationErrorsAction,
  deleteInvitationsAction,
  updateSelectionAction,
  respondInvitationAction,
  action,
  setTableAction,
  detail,
  selectable,
  keywordById,
  customColumnsData,
  customColumnsById,
  initialSelectedRowIds,
  updateCustomColumnsAction,
  notifiableIds,
  updateAssignmentAction,
  notifyAction,
  roleById,
  gridForms,
  deleteAssignmentAction,
  filteredIds,
  updateFilteredIdsAction,
  currentRole,
  user,
  keywordsLevels,
  resetExternalChangeCountAction,
  screenByName,
  emailRoleIds,
}) => {
  const { t, i18n } = useTranslation();
  const [exportDTO, setExportDTO] = useState<ExportDTO>({
    count: 0,
    rowsOption: 'all',
  });

  const handleGridSettingsChange = (gridSettings: gridSettingsProps, onSuccess?: () => void) => {
    const { gridColumnProps, dataState } = gridSettings;
    // Let's handle whether a column has been hidden and was taking part of the filters
    const all = gridColumnProps.map((columnProps) => columnProps.field);
    const hidden = gridColumnProps
      .filter((columnProps) => columnProps.orderIndex == 0)
      .map((columnProps) => columnProps.field);

    // Check filter fields
    let newDataState: State = { ...dataState };
    if (newDataState.filter?.filters.length) {
      newDataState = {
        ...newDataState,
        filter: {
          ...newDataState.filter,
          filters: newDataState.filter.filters
            .filter((filter) => {
              /* Filter out filters with "empty" values */
              const { value } = filter as FilterDescriptor;
              const ko = value == undefined || value == null || (typeof value == 'string' && !value);
              return !ko;
            })
            .filter((filter) => {
              const { field } = filter as FilterDescriptor;
              return all.includes(field) && !hidden.includes(field);
            }),
        },
      };
    }
    if (!newDataState.filter?.filters.length) {
      // @ts-ignore
      newDataState.filter = null;
    }

    // Check sort fields
    if (newDataState.sort?.length) {
      newDataState = {
        ...newDataState,
        sort: newDataState.sort.filter(
          // @ts-ignore
          (value) => all.includes(value.field) && !hidden.includes(value.field),
        ),
      };
    }

    const newGridSettings = {
      ...gridSettings,
      gridColumnProps: gridColumnProps.map((col) => {
        const { cell, ...rest } = col;
        return rest;
      }),
      dataState: newDataState,
    };

    // Trigger redux action
    setGridSettingsAction({ gridSettings: newGridSettings, friendlyName, onSuccess, fromExternal: true });

    return newGridSettings;
  };

  const _getSelectedRowIds = (selectedState: { [id: string]: boolean | number[] }): number[] => {
    return Object.entries(selectedState)
      .filter(([, selected]) => selected)
      .map(([rowId]) => parseInt(rowId));
  };

  /**
   * Returns an array containing the IDs of the selected rows in the table.
   */
  const getSelectedRowIds = (): number[] => {
    return _getSelectedRowIds(selectedState);
  };

  const getSelectedRows = (): Record<string, unknown>[] => {
    const rowIds = getSelectedRowIds();
    return allGridData.filter((row) => rowIds.includes(idGetter(row) as number));
  };

  const handleSelectRow = (newState: { [id: string]: boolean | number[] }) => {
    // Update local state...
    setSelectedState(newState);

    // Store selected ids in redux...
    updateSelectionAction(_getSelectedRowIds(newState), friendlyName);
  };

  /* Label button */
  const onClickApplyHandler = (checked: number[], indeterminate: number[]) => {
    const checkedSet = new Set(checked);
    const indeterminateSet = new Set(indeterminate);

    // Compute new label state for each selected row
    const labelsByRowId: { [key: number]: number[] } = {};
    selectedRows.forEach((row) => {
      const labels = row.label_ids as number[];
      const labelSet = new Set(labels);
      const newLabelSet = union(intersection(labelSet, indeterminateSet), checkedSet); // Tricky set operation to fast determinate new labels based on the checkbox selection
      const rowId = labelableIdGetter(row) as number;
      labelsByRowId[rowId] = Array.from(newLabelSet).sort();
    });

    if (Object.keys(labelsByRowId).length > 0) {
      pickLabelAction(labelsByRowId, friendlyName);
    }
  };

  const onClickLabelHandler = (labelId: number) => {
    const labelsByRowId: { [key: number]: number[] } = {};

    selectedRows.forEach((row) => {
      const labels = row.label_ids as number[];
      const labelSet = new Set(labels);

      labelSet.has(labelId) ? labelSet.delete(labelId) : labelSet.add(labelId);

      const newLabelArr = Array.from(labelSet);
      const rowId = labelableIdGetter(row) as number;
      labelsByRowId[rowId] = newLabelArr.sort();
    });

    if (Object.keys(labelsByRowId).length > 0) {
      pickLabelAction(labelsByRowId, friendlyName);
    }
  };

  const handleLabelsPopoverClose = () => {
    setLabelAnchorEl(null);
  };

  const handleLabelDialogOpen = (data: LabelDialogFields, labelId: null | number, mode: DialogMode) => {
    setLabelFields(data);
    setLabelId(labelId);
    setModeLabelDialog(mode);
    setOpenLabelDialog(true);
  };

  const handleLabelDialogClose = () => {
    setOpenLabelDialog(false);
  };

  const handleOnCreateClick = (data: LabelDialogFields) => {
    const set = new Set(selectedRows.map((row: any) => labelableIdGetter(row)));
    currentTrack && createLabelAction(data, friendlyName, currentTrack.id, Array.from(set));
    handleLabelDialogClose();
  };

  const handleOnUpdateClick = (labelId: number, data: LabelDialogFields) => {
    updateLabelAction(labelId, data);
    handleLabelDialogClose();
  };

  const handleOnDeleteClick = (labelId: number) => {
    deleteLabelAction(labelId, friendlyName);
    handleLabelDialogClose();
  };

  const getLabelsCount = () => {
    const labelIds = selectedRows.map((row) => row.label_ids) as number[][];

    // Count occurrences of labels across rows
    const counts: { [key: number]: number } = {};
    labelIds.forEach((labels) => {
      for (const labelId of labels) {
        if (!(labelId in counts)) counts[labelId] = 0;
        counts[labelId]++;
      }
    });

    return counts;
  };

  const parseQuestionId = (fieldId: string): number => {
    return parseInt(fieldId.split('_')[1]);
  };

  const getCustomColumnIdField = (customColumnId: number): string => {
    return `custom_${customColumnId}`;
  };

  const goToSubmissionDetail = (row: any) => {
    const selectedSubmission = row as unknown as Submission;
    history.push(
      fillRoutePath(getRouteByName('RouteDetailSubmission').path, {
        id: selectedSubmission.external_id.toString(),
      }),
    );
  };

  const goToBidsDetail = (row: any) => {
    history.push(
      fillRoutePath(
        getRouteByName(friendlyName == 'reviewers_bids' ? 'RouteReviewerBids' : 'RouteSubmissionBids').path,
        {
          id: friendlyName == 'reviewers_bids' ? idGetter(row) : row.external_id,
        },
      ),
    );
  };

  const goToReviewerAssignments = (row: any) => {
    history.push(
      fillRoutePath(getRouteByName('RouteAssignmentReviewersToPapersDetail').path, {
        id: idGetter(row),
      }),
    );
  };

  const goToSubmissionAssignments = (row: any, roleId: string) => {
    history.push(
      fillRoutePath(getRouteByName('RouteAssignmentsPapersToReviewersDetail').path, {
        submissionId: row.external_id,
        roleId,
      }),
    );
  };

  const goToReviewerToReviewerAssignments = (row: any) => {
    history.push(
      fillRoutePath(getRouteByName('RouteAssignmentsReviewersToReviewersDetail').path, {
        id: idGetter(row),
        roleId: row.to_role_id,
      }),
    );
  };

  /**
   * Decides the component to render in a cell of a grid based on the fieldId
   * @param fieldId
   */
  const getCustomCell = (fieldId: TableColumnId | string): ComponentType<GridCellProps> | undefined => {
    let MyCustomCell;

    if (fieldId === 'labels') {
      MyCustomCell = (props: GridCellProps) => (
        <LabelsCell
          {...props}
          unpickLabelAction={unpickLabelAction}
          labelsById={labelsById}
          tableFriendlyName={friendlyName}
          labelableIdKey={gridSettings.LABELABLE_ITEM_KEY}
        />
      );
    } else if (fieldId == 'paper_status') {
      MyCustomCell = (props: GridCellProps) => {
        return (
          <td
            colSpan={props.colSpan}
            className={`${props.className}`}
            role="gridcell"
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
            style={props.style}
          >
            <div className="flex">
              {currentRole && (
                <PaperStatusLabel
                  name={getPaperStatusName(props.dataItem)}
                  category={getPaperStatusCategory(props.dataItem)}
                />
              )}
            </div>
          </td>
        );
      };
    } else if (
      fieldId == 'title' &&
      [
        'submissions',
        'submissions_to_review',
        'papers_to_reviews',
        'submissions_bids',
        'reviewer_bids',
        'reviewer_assignments',
      ].includes(friendlyName)
    ) {
      MyCustomCell = (props: GridCellProps) => <TitleCell {...props} />;
    } else if (fieldId == 'abstract') {
      MyCustomCell = (props: GridCellProps) => <AbstractCell {...props} />;
    } else if (
      fieldId == 'external_id' &&
      [
        'submissions',
        'submissions_to_review',
        'papers_to_reviews',
        'submissions_bids',
        'reviewer_bids',
        'reviewer_assignments',
      ].includes(friendlyName)
    ) {
      MyCustomCell = (props: GridCellProps) => (
        <IdCell
          {...props}
          handleOnClick={() => {
            const rowId = idGetter(props.dataItem);
            handleSelectRow({ [rowId]: true });
            goToSubmissionDetail(props.dataItem);
          }}
          labelText={t('View')}
        />
      );
    } else if (fieldId == 'file_upload') {
      MyCustomCell = (props: GridCellProps) => <FileUploadCell {...props} />;
    } else if (friendlyName === 'invitations' && fieldId === 'body') {
      MyCustomCell = (props: GridCellProps) => (
        <BodyCell
          {...props}
          handleViewClick={(rowId) => {
            const row = allGridData.find((row) => rowId == idGetter(row)) as unknown as Invitation;
            // fetch
            setDialog(<InvitationBodyDialog id={rowId} onClose={() => setDialog(undefined)} />);
          }}
        />
      );
    } else if (isQuestionColumn(fieldId)) {
      const question = questionById[parseQuestionId(fieldId)];
      if (question) {
        MyCustomCell = (props: GridCellProps) => (
          <QuestionCell {...props} question={question} answerById={answerById} />
        );
      }
    } else if (isCustomColumn(fieldId)) {
      const colId = parseQuestionId(fieldId);
      const customColumn = customColumnsById[colId];
      const question = questionById[customColumn?.question_id ?? 0];
      if (customColumn?.operator == 'num_assignments') {
        if (['reviews_to_papers', 'reviewers_to_reviewers'].includes(friendlyName)) {
          const handler =
            friendlyName == 'reviews_to_papers' ? goToReviewerAssignments : goToReviewerToReviewerAssignments;
          MyCustomCell = (props: GridCellProps) => (
            <IdCell
              {...props}
              handleOnClick={() => {
                const rowId = idGetter(props.dataItem);
                handleSelectRow({ [rowId]: true });
                handler(props.dataItem);
              }}
              labelText={t('Edit')}
            />
          );
        } else if (['papers_to_reviews'].includes(friendlyName) && customColumn.role_id != null) {
          MyCustomCell = (props: GridCellProps) => (
            <IdCell
              {...props}
              handleOnClick={() => {
                const rowId = idGetter(props.dataItem);
                handleSelectRow({ [rowId]: true });
                goToSubmissionAssignments(props.dataItem, (customColumn?.role_id ?? 0).toString());
              }}
              labelText={t('Edit')}
            />
          );
        }
      } else if (
        customColumn?.operator == 'num_bids' &&
        ['reviewers_bids', 'submissions_bids'].includes(friendlyName) &&
        !customColumn.role_id
      ) {
        MyCustomCell = (props: GridCellProps) => {
          return (
            <IdCell
              {...props}
              handleOnClick={() => {
                const rowId = idGetter(props.dataItem);
                handleSelectRow({ [rowId]: true });
                goToBidsDetail(props.dataItem);
              }}
              labelText={t('View')}
            />
          );
        };
      } else if (customColumn?.operator == 'aggregate' && question?.type == 'Comment') {
        MyCustomCell = (props: GridCellProps) => {
          return (
            <td
              colSpan={props.colSpan}
              className={props.className}
              role="gridcell"
              aria-colindex={props.ariaColumnIndex}
              aria-selected={props.isSelected}
              style={props.style}
            >
              <span style={{ whiteSpace: 'pre-line' }}>{props.dataItem[props.field || '']}</span>
            </td>
          );
        };
      }
    } else if (fieldId == 'keywords') {
      MyCustomCell = (props: GridCellProps) => (
        <KeywordsCell {...props} keywordById={keywordById} groupByParent={keywordsLevels == 2} />
      );
    } else if (
      fieldId == 'assigned' &&
      ['reviewer_assignments', 'submission_assignments', 'reviewer_assignments_of_reviewers'].includes(friendlyName)
    ) {
      MyCustomCell = (props: GridCellProps) => {
        return (
          <AssignedCell
            {...props}
            idKey={tableSettings.gridSettings.DATA_ITEM_KEY}
            handleAssignedClick={(id, assigned, assignmentId, skipConflicts) => {
              handleSelectRow({ [id]: true });
              updateAssignmentAction?.(id, assigned, assignmentId, skipConflicts);
            }}
            notifiableIds={notifiableIds}
            handleNotifyClick={notifyAction}
          />
        );
      };
    } else if (fieldId == 'conflict') {
      MyCustomCell = (props: GridCellProps) => <ConflictCell {...props} />;
    }

    return MyCustomCell;
  };

  const getCustomFilterCell = (columnProps: GridColumnProps) => {
    const colId = columnProps.id ?? '';
    /* Determine whether we need to use a custom filter cell */
    let filterCell;
    if (
      [
        'labels',
        'main_area',
        'validation_status',
        'paper_status',
        'roles',
        'role',
        'country',
        'status',
        'bid',
      ].includes(colId) ||
      (isQuestionColumn(colId) &&
        (['Select', 'MultiSelect', 'LikertScale', 'Agreement'] as QuestionType[]).includes(
          questionById[parseQuestionId(colId)]?.type,
        ))
    ) {
      filterCell = (props: GridFilterCellProps) => <MultiSelectFilterCell {...props} data={allGridData} />;
    } else if (columnProps.filter == 'date') {
      filterCell = DateFilterCell;
    } else if (['external_id', 'email'].includes(colId)) {
      filterCell = IdFilterCell;
    }
    return filterCell;
  };

  function hasSelectedRows(): boolean {
    if (selectedRows.length > 0) {
      return true;
    } else {
      openSnackBarAction({ message: t('You need to select at least one row'), severity: 'warning' });
      return false;
    }
  }

  /**
   * Determines whether selected rows are applicable to the target action
   * @param actionOption
   */
  function areSelectedRowsApplicable(actionOption: actionOption): boolean {
    for (const row of selectedRows) {
      const actions = getRowActions(row).map((action) => action.id);
      if (!actions.includes(actionOption)) {
        openSnackBarAction({
          message:
            actionOption == 'send-email:invitation'
              ? t(
                  "You can't resend invitations that are already responded. Please unselect those rows that are either Accepted or Declined.",
                )
              : t('There are selected rows that are not applicable for this action'),
          severity: 'warning',
        });
        return false;
      }
    }
    return true;
  }

  const getRowActions = (record: Record<string, unknown>): RowAction[] => {
    let rowActions = rowActionsForTable;
    if (initRowActions) {
      rowActions = rowActions.concat(initRowActions[idGetter(record)] ?? []);
    }

    switch (friendlyName) {
      case 'submissions':
      case 'submissions_to_review': {
        const submission = record as unknown as Submission;
        return rowActions.filter((rowAction) => {
          let filter = true;
          if (
            (['edit-paper-status'] as actionOption[]).includes(rowAction.id) &&
            currentRole &&
            !new SubmissionPermissionManager(submission).canEditPaperStatus(currentRole)
          ) {
            filter = false;
          } else if (
            (['join-discussion'] as actionOption[]).includes(rowAction.id) &&
            currentRole &&
            !new SubmissionPermissionManager(submission).canViewDiscussion(user, currentRole)
          ) {
            filter = false;
          }
          return filter;
        });
      }
      case 'invitations': {
        const row = record as unknown as Invitation;
        return rowActions.filter((rowAction) => {
          let filter = true;
          // Skip resend, respond and delete actions if invitation is already responded.
          if (
            (['send-email:invitation', 'respond:invitation', 'delete:invitation'] as actionOption[]).includes(
              rowAction.id,
            ) &&
            (['Accepted', 'Declined', 'Sending'] as InvitationStatus[]).includes(row.status)
          ) {
            filter = false;
          }
          return filter;
        });
      }
      case 'users': {
        const row = record as unknown as PersonTableRow;
        const find = row.role_ids.find((roleId) => roleById[roleId].type == 'author');
        if (find) {
          rowActions = rowActions.filter((rowAction) => rowAction.id != 'remove-person');
        }
        return rowActions;
      }
      case 'reviewers_bids':
        return rowActions.filter((rowAction) => {
          const roleId = record.role_id as number;
          let filter = true;
          // Skip create subset bid if either subset bidding or keywords are disabled
          if (
            (['create-subset-bid'] as actionOption[]).includes(rowAction.id) &&
            (!screenByName['Subset Bidding'][roleId].settings.enabled || !currentTrack?.using_keywords)
          ) {
            filter = false;
          }
          return filter;
        });
      case 'people_to_review':
        const row = record as unknown as { role_id: number };
        return rowActions.filter((rowAction) => {
          let filter = true;
          // Skip create subset bid if either subset bidding or keywords are disabled
          if (
            (['send-email:people_role'] as actionOption[]).includes(rowAction.id) &&
            !emailRoleIds.includes(row.role_id)
          ) {
            filter = false;
          }
          return filter;
        });
      default:
        return rowActions;
    }
  };

  const addLabels = (newRegister: Record<string, unknown>) => {
    if (hasLabelsColumn) {
      const modelClass = tableSettings.model;
      // @ts-ignore
      newRegister.label_ids = labelables[modelClass][labelableIdGetter(newRegister)] ?? [];
      // @ts-ignore
      newRegister.labels = newRegister.label_ids.map((id) => labelsByIdForTable[id].label).join(';');
    }
  };

  const initData = () => {
    /* Initialize form questions */
    const questionColumnProps = gridSettings.gridColumnProps.filter((e) => isQuestionColumn(e.id));
    const customColumnProps = gridSettings.gridColumnProps.filter((e) => isCustomColumn(e.id));

    /* Arrange data for Kendo Grid */
    const newData: Record<string, unknown>[] = [];
    inputData.forEach((register) => {
      let newRegister = { ...register };

      /* Initialize labels */
      addLabels(newRegister);

      /* Set selected to false */
      newRegister[gridSettings.SELECTED_FIELD] = false;
      newRegister['table_friendly_name'] = friendlyName;

      /* Initialize row actions fields */
      const actions = getRowActions(newRegister);
      newRegister['row_actions'] =
        actions.length > 0 ? (
          <div>
            <ActionsKmenu
              actions={actions}
              onSelect={(event) => {
                if (!event.item.data) return;
                const action = actions.find((x) => x.id == event.item.data.id);
                if (action && action.callback) {
                  const rowId = idGetter(newRegister);
                  handleSelectRow({ [rowId]: true });
                  // @ts-ignore
                  action.callback(newRegister);
                }
              }}
            />
          </div>
        ) : undefined;

      /* Create form questions fields */
      questionColumnProps.forEach((columnProp) => {
        const questionId = parseQuestionId(columnProp.id);
        const question = questionById[questionId];

        let answer: Answer | undefined;
        if (question) {
          const id = getCompositeAnswerId(question.id, idGetter(newRegister));
          answer = answerById[id];
        } else {
          answer = undefined;
        }
        newRegister[columnProp.field] = toKendoGridValue(question, answer);
      });

      /* Add custom columns fields */
      let data: { [key: string]: any };
      if (customColumnsData[friendlyName] && customColumnsData[friendlyName][idGetter(newRegister)]) {
        data = { ...customColumnsData[friendlyName][idGetter(newRegister)] };
      } else {
        data = {};
      }
      // Initialize cells with no value
      customColumnProps.forEach((columnProp) => {
        const customColumn = customColumnsById[parseQuestionId(columnProp.id)];
        const field = getCustomColumnIdField(customColumn.id);
        if (!data.hasOwnProperty(field)) {
          // Initialize field with empty value
          //if (operator.filter == 'numeric' && isOtherColumnOperator(column.operator)) {
          if (columnProp.filter == 'numeric') {
            data[field] = 0;
          } else if (columnProp.filter == 'text') {
            data[field] = 'N/A';
          } else {
            data[field] = undefined;
          }
        }
      });
      newRegister = { ...newRegister, ...data };

      newData.push(newRegister);
    });

    return newData;
  };

  const initSelectedState = () => {
    const selectedFromRedux: { [key: string]: boolean } = {};

    Object.values(initialSelectedRowIds[friendlyName]).forEach((id) => {
      selectedFromRedux[id.toString()] = true;
    });

    return selectedFromRedux;
  };

  const getSendEmailDialog = (action: actionOption, rows: Record<string, unknown>[]) => {
    let dialogTitle = '';
    switch (action) {
      case 'send-email:author':
        dialogTitle = t('Send email to authors');
        break;
      case 'send-email:contact_author':
        dialogTitle = t('Send email to managing authors');
        break;
      case 'send-email:submissions_reviewers':
        dialogTitle = t('Send email to reviewers');
        break;
      case 'send-email:people':
      case 'send-email:people_role':
        dialogTitle = t('Send email to people');
        break;
    }
    const rowIds: number[] = ['reviews_to_papers', 'reviewers_bids'].includes(friendlyName)
      ? rows.map((row) => row.person_id as number)
      : rows.map((row) => idGetter(row));
    const recipientType: EmailRecipientType = action.split(':')[1] as EmailRecipientType;

    const handleClose = () => {
      setTableAction('');
      setDialog(undefined);
    };

    const emailDialogProps = {
      modelIds: rowIds,
      recipientType,
      title: dialogTitle,
      handleClose,
    };

    return recipientType == 'submissions_reviewers' ? (
      <RolesDialog
        title={dialogTitle}
        label={t('Select roles')}
        initialOption={[]}
        roleOptions={Object.values(roleById).filter((value) => value.type == 'reviewer')}
        open={true}
        handleClose={handleClose}
        closeOnOk={false}
        doOkClick={(selectedOption: string[]) =>
          setDialog(
            <SendEmailDialog {...emailDialogProps} recipientRoleIds={selectedOption.map((value) => parseInt(value))} />,
          )
        }
      />
    ) : (
      <SendEmailDialog {...emailDialogProps} />
    );
  };

  const getExportDialog = () => {
    return (
      <ExportTableDialog
        open={true}
        handleClose={() => setDialog(undefined)}
        handleOk={(columnsOption, rowsOption) => {
          //const ids = rowsOption == 'selected' ? selectedRowIds : allGridData.map((row) => idGetter(row));
          //downloadWithIds(ids, `/web/tables/${friendlyName}/export?columns=${columnsOption}`);
          setExportDTO({
            ...exportDTO,
            count: exportDTO.count + 1,
            rowsOption,
          });
        }}
        title={t('Export data')}
        closeOnOk={true}
        numSelected={selectedRowIds.length}
      />
    );
  };

  const getMenuItem = (
    value: TableSettings,
    currentSettings: TableSettings,
    index: number,
    subitems?: JSX.Element[],
  ) => {
    const name = getTableViewName(value.name, t);
    return (
      <KMenuItem
        key={index}
        // @ts-ignore
        text={
          <div className={`flex items-center ${value.is_current ? '-ml-1' : ''}`}>
            {value.has_filters ? (
              <FontAwesomeIcon icon={faFilter} color={theme.palette.primary.main} width="15" />
            ) : (
              <FilterOutlined width="15" />
            )}
            <span className="ml-1.5">{isModified(value) ? name + ' ' + t('(modified)') : name}</span>
          </div>
        }
        cssStyle={value.id == currentSettings.source_id ? { fontWeight: 'bold' } : { fontWeight: 'normal' }}
        data={{ id: value.id }}
      >
        {subitems}
      </KMenuItem>
    );
  };

  const getMenuItems = (): JSX.Element[] => {
    // Get current grid settings
    const currentSettings = tableSettings;

    // Get the others
    const restSettings = otherTablesSettings[friendlyName] ?? [];

    // Compute columns menu items
    const menuItems = restSettings
      .filter((value) => currentSettings.source_id != value.id)
      .map((value, index) => getMenuItem(value, currentSettings, index));
    menuItems.push(
      <KMenuItem
        key={menuItems.length}
        text=""
        disabled={true}
        cssStyle={{ borderTop: '1px dashed #707073', marginTop: '5px' }}
      />,
    );
    /* Here start the actions */
    if (isModified(currentSettings)) {
      menuItems.push(
        <KMenuItem
          key={menuItems.length}
          text={t('Restore') + ` '${currentSettings.name}'`}
          cssStyle={{ fontSize: '0.75rem' }}
          data={{ id: 'Restore' }}
        />,
      );
    }
    const source = restSettings.find((value) => value.id == currentSettings.source_id);
    if (source && !source.read_only && isModified(currentSettings)) {
      menuItems.push(
        <KMenuItem key={menuItems.length} text={t('Save')} cssStyle={{ fontSize: '0.75rem' }} data={{ id: 'Save' }} />,
      );
    }
    menuItems.push(
      <KMenuItem
        key={menuItems.length}
        text={t('Save as')}
        cssStyle={{ fontSize: '0.75rem' }}
        data={{ id: 'Save as' }}
      />,
    );
    if (source && !source.read_only) {
      menuItems.push(
        <KMenuItem
          key={menuItems.length}
          text={t('Delete') + ` '${currentSettings.name}'`}
          cssStyle={{ fontSize: '0.75rem' }}
          data={{ id: 'Delete' }}
        />,
      );
    }
    return menuItems;
  };

  const resizeFont = (action: 'increase' | 'decrease' | 'reset') => {
    let gridSettingsProps: gridSettingsProps;

    switch (action) {
      case 'increase':
        gridSettingsProps = { ...gridSettings, fontSize: gridSettings.fontSize + 1 };
        break;
      case 'decrease':
        gridSettingsProps = { ...gridSettings, fontSize: gridSettings.fontSize - 1 };
        break;
      case 'reset':
        gridSettingsProps = { ...gridSettings, fontSize: DEFAULT_FONT_SIZE };
        break;
    }
    handleGridSettingsChange(gridSettingsProps);
  };

  const isModified = (settings: TableSettings): boolean => {
    return settings.columns_changed || settings.filters_changed;
  };

  const handleFiltersPopoverClose = () => {
    setFiltersAnchorEl(null);
  };

  const getNumFilters = (): number => {
    let total = 0;
    if (dataState.filter) {
      dataState.filter.filters.forEach((value) => {
        const filter = value as FilterDescriptor;
        total += Array.isArray(filter.value) ? filter.value.length : 1;
      });
    }
    return total;
  };

  // Initialize gridSettings...
  const tableSettings = tablesSettings[friendlyName];
  const { gridSettings, filterBox, model } = tableSettings;
  const { dataState } = gridSettings;

  const idGetter = getter(gridSettings.DATA_ITEM_KEY);
  const labelableIdGetter = getter(gridSettings.LABELABLE_ITEM_KEY);

  /* Initialize labels things... */
  const hasLabelsColumn = gridSettings.gridColumnProps.find((e) => e.id === 'labels') !== undefined;
  const labelsByIdForTable: { [key: number]: Label } = {};
  if (hasLabelsColumn) {
    Object.values(labelsById)
      .filter((label) => label.model === tableSettings.model)
      .forEach((label) => {
        labelsByIdForTable[label.key] = label;
      });
  }

  /* Define table bulk actions */
  const bulkActions: { [key: string]: Action[] } = {
    submissions: [
      {
        id: 'download-submissions',
        label: t('Download submissions'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(
              <DownloadSubmissionsDialog
                open={true}
                handleClose={() => setDialog(undefined)}
                handleOk={(uploadOptions: number[]) => {
                  const queryString = uploadOptions
                    .map((uploadOptions) => `upload_options[]=${uploadOptions}`)
                    .join('&');
                  downloadWithIds(selectedRowIds, `/web/submissions/download?${queryString}`);
                }}
              />,
            );
          }
        },
      },
      {
        id: 'send-email:author',
        label: t('Send email to authors'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(getSendEmailDialog('send-email:author', selectedRows));
          }
        },
      },
      {
        id: 'send-email:contact_author',
        label: t('Send email to managing authors'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(getSendEmailDialog('send-email:contact_author', selectedRows));
          }
        },
      },
      {
        id: 'send-email:submissions_reviewers',
        label: t('Send email to reviewers'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(getSendEmailDialog('send-email:submissions_reviewers', selectedRows));
          }
        },
      },
      {
        id: 'edit-paper-status',
        label: t('Edit paper status'),
        callback: () => {
          if (hasSelectedRows() && currentRole) {
            const rows = selectedRows;
            setDialog(
              <PaperStatusChangeDialog
                initialOption={rows.length == 1 ? (rows[0].paper_status_id as string) : undefined}
                submissionIds={rows.map((row) => idGetter(row))}
                open={true}
                handleClose={() => setDialog(undefined)}
                role={currentRole}
              />,
            );
          }
        },
      },
      {
        id: 'export-data',
        label: t('Export data'),
        callback: () => {
          setDialog(getExportDialog());
        },
      },
      {
        id: 'delete-submission',
        label: t('Delete submissions'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(
              <ChairDeleteSubmissionDialog
                submissionIds={selectedRowIds}
                open={true}
                handleClose={() => setDialog(undefined)}
              />,
            );
          }
        },
      },
      {
        id: 'new-submission',
        label: t('New submission'),
        callback: () => history.push(fillRoutePath(getRouteByName('RouteNewSubmission').path)),
      },
    ],
    users: [
      {
        id: 'send-email:people',
        label: t('Send email'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(getSendEmailDialog('send-email:people', selectedRows));
          }
        },
      },
      {
        id: 'export-data',
        label: t('Export data'),
        callback: () => {
          setDialog(getExportDialog());
        },
      },
      {
        id: 'add-person',
        label: t('Add person'),
        callback: () => {
          setDialog(
            <AddPersonDialog
              handleClose={() => {
                setDialog(undefined);
                clearValidationErrorsAction();
              }}
            />,
          );
        },
      },
    ],
    invitations: [
      {
        id: 'send-email:new-invitation',
        label: t('New invitation'),
        callback: () =>
          setDialog(<InvitationDialog title={t('New Invitation')} handleClose={() => setDialog(undefined)} />),
      },
      {
        id: 'send-email:invitation',
        label: t('Resend invitation'),
        callback: () => {
          if (hasSelectedRows() && areSelectedRowsApplicable('send-email:invitation')) {
            setDialog(
              <InvitationDialog
                title={t('Resend invitation')}
                initType="ids"
                initInput={selectedRowIds}
                initStep={1}
                handleClose={() => setDialog(undefined)}
              />,
            );
          }
        },
      },
    ],
    reviews_to_papers: [
      {
        id: 'send-email:people',
        label: t('Send email'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(getSendEmailDialog('send-email:people', selectedRows));
          }
        },
      },
      {
        id: 'delete-assignment',
        label: t('Delete assignment'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(
              <DeleteAssignmentDialog
                count={selectedRowIds.length}
                type="reviewer"
                handleClose={() => setDialog(undefined)}
                handleOk={(withReviews) =>
                  deleteAssignmentAction({
                    ids: selectedRowIds,
                    with_reviews: withReviews,
                    tableFriendlyName: friendlyName,
                  })
                }
              />,
            );
          }
        },
      },
    ],
    papers_to_reviews: [
      {
        id: 'delete-assignment',
        label: t('Delete assignment'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(
              <DeleteAssignmentDialog
                count={selectedRowIds.length}
                type="submission"
                handleClose={() => setDialog(undefined)}
                handleOk={(withReviews) =>
                  deleteAssignmentAction({
                    ids: selectedRowIds,
                    with_reviews: withReviews,
                    tableFriendlyName: friendlyName,
                  })
                }
              />,
            );
          }
        },
      },
    ],
    reviewers_bids: [
      {
        id: 'send-email:people',
        label: t('Send email'),
        callback: () => {
          if (hasSelectedRows()) {
            setDialog(getSendEmailDialog('send-email:people', selectedRows));
          }
        },
      },
    ],
  };
  const bulkActionsForTable = (bulkActions[friendlyName] ?? []).sort((a, b) => {
    const nameA = a.label.toUpperCase(); // ignore upper and lowercase
    const nameB = b.label.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  });

  /* Define row actions */
  const rowActions: { [key: string]: RowAction[] } = {
    users: [
      {
        id: 'impersonate',
        label: t('Impersonate'),
        callback: (row) => {
          const personRow = row as unknown as PersonTableRow;
          impersonateAction({ person_id: personRow.id });
        },
      },
      {
        id: 'edit-roles',
        label: t('Edit roles'),
        callback: (row) => {
          const rows = [row];
          let initialOption: string[];
          if (rows.length == 1) {
            const roleIds = rows[0].role_ids as number[];
            initialOption = roleIds.map((value) => value.toString());
          } else {
            initialOption = [];
          }
          setDialog(
            <RolesDialog
              title={t('Edit roles')}
              label={t(`Please select which roles the user should have`)}
              initialOption={initialOption}
              roleOptions={Object.values(roleById).filter((value) => value.type != 'author')}
              open={true}
              handleClose={() => setDialog(undefined)}
              doOkClick={(selectedOption: string[]) => {
                const rowId = idGetter(row);
                const data: { [key: number]: number[] } = {};
                [rowId].forEach((personId) => {
                  data[personId] = selectedOption.map((value) => parseInt(value));
                });
                updateUserRolesBulkAction({ data });
              }}
            />,
          );
        },
      },
      {
        id: 'remove-person',
        label: t('Remove from track'),
        callback: (row) => {
          const person = row as unknown as PersonTableRow;
          const data: { [key: number]: number[] } = { [person.id]: [] };
          setDialog(
            <SimpleDialog
              open={true}
              handleClose={() => setDialog(undefined)}
              handleOk={() => updateUserRolesBulkAction({ data })}
              title={t('Remove from track')}
            >
              <p>
                {t(`Are you sure you want to remove {{email}} from this track?`, {
                  email: person.email,
                })}
              </p>
            </SimpleDialog>,
          );
        },
      },
    ],
    submissions: [
      {
        id: 'view-submission',
        label: t('View submission'),
        callback: goToSubmissionDetail,
      },
      {
        id: 'edit-submission',
        label: t('Edit submission'),
        callback: (row) => {
          const selectedSubmission = row as unknown as Submission;
          history.push(
            fillRoutePath(getRouteByName('RouteEditSubmission').path, {
              id: selectedSubmission.external_id.toString(),
            }),
          );
        },
      },
      {
        id: 'delete-submission',
        label: t('Delete submission'),
        callback: (row) => {
          const selectedSubmission = row as unknown as Submission;
          setDialog(
            <ChairDeleteSubmissionDialog
              submissionIds={[selectedSubmission.id]}
              open={true}
              handleClose={() => setDialog(undefined)}
            />,
          );
        },
      },
      {
        id: 'edit-paper-status',
        label: t('Edit paper status'),
        callback: (row) => {
          if (currentRole) {
            const rowId = idGetter(row);
            const rows = [row];
            setDialog(
              <PaperStatusChangeDialog
                initialOption={rows.length == 1 ? (rows[0].paper_status_id as string) : undefined}
                submissionIds={[rowId]}
                open={true}
                handleClose={() => setDialog(undefined)}
                role={currentRole}
              />,
            );
          }
        },
      },
      {
        id: 'join-discussion',
        label: t('Join discussion'),
        callback: (row) => {
          if (currentRole) {
            const selectedSubmission = row as unknown as Submission;
            history.push(
              fillRoutePath(getRouteByName('RouteDiscussions').path, {
                submissionId: selectedSubmission.external_id.toString(),
              }),
            );
          }
        },
      },
    ],
    submissions_to_review: [
      {
        id: 'view-submission',
        label: t('View submission'),
        callback: goToSubmissionDetail,
      },
      {
        id: 'edit-paper-status',
        label: t('Edit paper status'),
        callback: (row) => {
          if (currentRole) {
            const rowId = idGetter(row);
            const rows = [row];
            setDialog(
              <PaperStatusChangeDialog
                initialOption={rows.length == 1 ? (rows[0].paper_status_id as string) : undefined}
                submissionIds={[rowId]}
                open={true}
                handleClose={() => setDialog(undefined)}
                role={currentRole}
              />,
            );
          }
        },
      },
      {
        id: 'join-discussion',
        label: t('Join discussion'),
        callback: (row) => {
          if (currentRole) {
            const selectedSubmission = row as unknown as Submission;
            history.push(
              fillRoutePath(getRouteByName('RouteDiscussions').path, {
                submissionId: selectedSubmission.external_id.toString(),
              }),
            );
          }
        },
      },
    ],
    invitations: [
      {
        id: 'send-email:invitation',
        label: t('Resend invitation'),
        callback: (row) => {
          const rowId = idGetter(row);
          const rowIds = [rowId];
          setDialog(
            <InvitationDialog
              title={t('Resend invitation')}
              initType="ids"
              initInput={rowIds}
              initStep={1}
              handleClose={() => setDialog(undefined)}
            />,
          );
        },
      },
      {
        id: 'delete:invitation',
        label: t('Delete invitation'),
        callback: (row) => {
          const rowId = idGetter(row);
          setDialog(
            <SimpleDialog
              open={true}
              handleClose={() => setDialog(undefined)}
              handleOk={() => deleteInvitationsAction([rowId])}
              title={t('Delete invitation') + '?'}
            >
              <p>
                {t(
                  `Are you sure you want to remove the current invitation? Take into account that this action can't be undone.`,
                )}
              </p>
            </SimpleDialog>,
          );
        },
      },
      {
        id: 'respond:invitation',
        label: t('Respond invitation'),
        callback: (row) => {
          const rowId = idGetter(row);
          setDialog(
            <RespondInvitationDialog
              open={true}
              handleClose={() => setDialog(undefined)}
              handleOk={(data) => respondInvitationAction({ ...data, id: rowId })}
            />,
          );
        },
      },
    ],
    papers_to_reviews: [
      ...Object.values(roleById)
        .filter((role) => role.type == 'reviewer' && !doesHandleReviewers(role))
        .map((role) => {
          return {
            id: `edit-assignments-${role.id}`,
            label: t('Edit {{roleName}} assignments', { roleName: role.description }),
            callback: (row) => goToSubmissionAssignments(row, role.id.toString()),
          } as RowAction;
        }),
      {
        id: 'delete-assignment',
        label: t('Delete assignment'),
        callback: (row) => {
          const rowId = idGetter(row);
          const selectedRowIds = [rowId];
          setDialog(
            <DeleteAssignmentDialog
              count={selectedRowIds.length}
              type="submission"
              handleClose={() => setDialog(undefined)}
              handleOk={(withReviews) =>
                deleteAssignmentAction({
                  ids: selectedRowIds,
                  with_reviews: withReviews,
                  tableFriendlyName: friendlyName,
                })
              }
            />,
          );
        },
      },
    ],
    reviews_to_papers: [
      {
        id: 'impersonate',
        label: t('Impersonate'),
        callback: (row) => {
          const personRow = row as unknown as PersonTableRow;
          impersonateAction({ person_id: personRow.person_id });
        },
      },
      {
        id: 'edit-assignments',
        label: t('Edit assignments'),
        callback: goToReviewerAssignments,
      },
      {
        id: 'delete-assignment',
        label: t('Delete assignment'),
        callback: (row) => {
          const rowId = idGetter(row);
          const selectedRowIds = [rowId];
          setDialog(
            <DeleteAssignmentDialog
              count={selectedRowIds.length}
              type="reviewer"
              handleClose={() => setDialog(undefined)}
              handleOk={(withReviews) =>
                deleteAssignmentAction({
                  ids: selectedRowIds,
                  with_reviews: withReviews,
                  tableFriendlyName: friendlyName,
                })
              }
            />,
          );
        },
      },
    ],
    reviewers_bids: [
      {
        id: 'impersonate',
        label: t('Impersonate'),
        callback: (row) => {
          const personRow = row as unknown as PersonTableRow;
          impersonateAction({ person_id: personRow.person_id });
        },
      },
      {
        id: 'view-bids',
        label: t('View bids'),
        callback: goToBidsDetail,
      },
      {
        id: 'create-subset-bid',
        label: t('Create subset bid'),
        callback: (row) =>
          setDialog(<CreateSubsetBidDialog rowId={idGetter(row)} handleClose={() => setDialog(undefined)} />),
      },
    ],
    submissions_bids: [
      {
        id: 'view-bids',
        label: t('View bids'),
        callback: goToBidsDetail,
      },
    ],
    reviewers_to_reviewers: [
      {
        id: 'edit-assignments',
        label: t('Edit assignments'),
        callback: goToReviewerToReviewerAssignments,
      },
    ],
    people_to_review: [
      {
        id: 'send-email:people_role',
        label: t('Send email'),
        callback: (row) => {
          setDialog(getSendEmailDialog('send-email:people_role', [row]));
        },
      },
    ],
  };
  const rowActionsForTable = (rowActions[friendlyName] ?? []).sort((a, b) => {
    const nameA = a.label.toUpperCase(); // ignore upper and lowercase
    const nameB = b.label.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  });

  // ---------------------- Start hooks definition
  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>(() => initSelectedState()); // Stores which rows are selected

  /* labels button */
  const [labelAnchorEl, setLabelAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [openLabelDialog, setOpenLabelDialog] = React.useState(false);
  const [labelId, setLabelId] = React.useState<number | null>(null);
  const [labelFields, setLabelFields] = React.useState<LabelDialogFields>({
    backgroundColor: '',
    name: '',
    textColor: '',
  });
  const [modeLabelDialog, setModeLabelDialog] = React.useState<DialogMode>('create');

  const [dialog, setDialog] = useState<JSX.Element | undefined>(undefined);

  /* Filters */
  const [showFilters, setShowFilters] = React.useState<boolean>(true);
  const [filtersAnchorEl, setFiltersAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const numFilters = getNumFilters();

  const theme = useTheme();

  const isSmallScreen = useWindowSize() < 1500;

  useEffect(() => {
    return () => {
      resetExternalChangeCountAction(friendlyName);
    };
  }, []);

  // ---------------------- End hooks definition

  /* Columns that must be shown always */
  const alwaysShown: TableColumnId[] | undefined = [
    'reviewer_assignments',
    'submission_assignments',
    'reviewer_assignments_of_reviewers',
  ].includes(friendlyName)
    ? ['assigned']
    : undefined;

  /* Here we'll make use of useMemo so that we can cache the data initialization process result as it can be time-consuming when data volume increases to thousands of records.
  This process will be re-triggered whenever row labels, aggregated columns or input data changes.
  */
  const allGridData = useMemo(
    () => initData(),
    [labelables[tableSettings.model], customColumnsData[friendlyName], JSON.stringify(inputData)],
  );

  const selectedRows = getSelectedRows();
  const selectedRowIds: number[] = selectedRows.map((row) => idGetter(row));

  /* Labels dialog and popover */
  let labelDialog;
  let popLabel;
  if (hasLabelsColumn) {
    labelDialog = (
      <LabelDialog
        open={openLabelDialog}
        onClose={handleLabelDialogClose}
        onCreate={handleOnCreateClick}
        onUpdate={handleOnUpdateClick}
        onDelete={handleOnDeleteClick}
        labelId={labelId}
        initLabelFields={labelFields}
        mode={modeLabelDialog}
      />
    );

    const open = Boolean(labelAnchorEl);
    popLabel = (
      <Popover
        open={open}
        anchorEl={labelAnchorEl}
        onClose={handleLabelsPopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <StyledPopoverContent>
          <LabelPicker
            allLabels={Object.values(labelsByIdForTable)}
            getCountsByLabelId={getLabelsCount}
            onClickApply={onClickApplyHandler}
            closePopOver={handleLabelsPopoverClose}
            numSelectedRows={selectedRowIds.length}
            openCreateLabelDialog={handleLabelDialogOpen}
            onManageClick={() => setTableAction('manage-labels')}
            onClickLabel={onClickLabelHandler}
          />
        </StyledPopoverContent>
      </Popover>
    );
  }

  switch (action) {
    case 'manage-labels':
      return (
        <div>
          <ManageLabels
            labelsById={labelsByIdForTable}
            openLabelDialog={handleLabelDialogOpen}
            onBackClick={() => setTableAction('')}
          />
          {labelDialog}
        </div>
      );
  }

  let filteredIdsKey: FilterIdsKey;
  switch (friendlyName) {
    case 'reviewers_to_reviewers':
      filteredIdsKey = friendlyName;
      break;
    default:
      filteredIdsKey = model;
      break;
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <div className="h-full flex flex-col pb-6">
          <div className="flex w-full rounded-lg mb-2 justify-between gridToolbox">
            {/* TOOLBOX 1 */}
            <StyledTools className="flex items-center" style={{ flexGrow: 1 }}>
              {/* CONFIGS */}
              <div className="tool-box rounded-md p-1 flex configsWrapper">
                <div className="flex pl-1.5 items-center">
                  <FontAwesomeIcon icon={faEye} className="text-white" />
                  <div className="ml-2 text-sm text-white">
                    <span className="buttonLabel">{t('Selected view')}</span>
                  </div>
                </div>
                <StyledKmenu
                  openOnClick
                  onSelect={(event) => {
                    if (!event.item.data) return;
                    const itemId = event.item.data.id;

                    switch (itemId) {
                      case 'Restore': {
                        const ts = (otherTablesSettings[friendlyName] ?? []).find(
                          (value) => value.id == tableSettings.source_id,
                        );
                        if (ts) {
                          loadSettingsAction({ personalSettingsId: ts.id });
                        }
                        break;
                      }
                      case 'Save': {
                        saveSettingsAction(friendlyName);
                        break;
                      }
                      case 'Save as':
                        {
                          const namesInUse = new Set(
                            (otherTablesSettings[friendlyName] ?? []).map((value) => value.name.trim().toLowerCase()),
                          );
                          setDialog(
                            <SaveTableSettingsDialog
                              open={true}
                              handleClose={() => setDialog(undefined)}
                              onSaveAs={(name: string) =>
                                saveAsSettingsAction({
                                  friendlyName,
                                  name,
                                  gridSettings,
                                })
                              }
                              namesNotAllowed={Array.from(namesInUse)}
                            />,
                          );
                        }
                        break;
                      case 'Delete': {
                        deleteSettingsAction({ friendlyName });
                        break;
                      }
                      default: {
                        // case Load
                        const ts = (otherTablesSettings[friendlyName] ?? []).find((value) => value.id == itemId);
                        if (ts && ts.name != tableSettings.name) {
                          loadSettingsAction({ personalSettingsId: ts.id, onSuccess: getCustomColumnsData });
                        }
                        break;
                      }
                    }
                  }}
                >
                  {getMenuItem(tableSettings, tableSettings, 0, getMenuItems())}
                </StyledKmenu>
              </div>

              {/* SYNC */}
              {getInfoAction && (
                <StyledButtonWrapper className="toolboxButtonWrapper" marginLeft="0.1rem">
                  <MUIButton
                    variant="outlined"
                    aria-label="sync table"
                    onClick={() => {
                      getInfoAction();
                    }}
                    startIcon={<FontAwesomeIcon icon={faSync} />}
                    disableRipple
                    style={{ borderColor: 'transparent' }}
                  >
                    <span className="buttonLabel">{t('Update')}</span>
                  </MUIButton>
                </StyledButtonWrapper>
              )}
            </StyledTools>

            {/* TOOLBOX 2 */}
            <StyledTools className="flex">
              {(['reviews_to_papers', 'papers_to_reviews', 'reviewers_to_reviewers'] as TableFriendlyName[]).includes(
                friendlyName,
              ) && (
                <div className="flex items-center mr-4">
                  <HowItWorksButton src="https://embed.app.guidde.com/playbooks/5A4KZoC8h3g4id8sp9tGWK" />
                </div>
              )}
              {/* FONT RESIZE */}
              <StyledFontResizeWrapper className="flex items-center resizeWrapper">
                <span style={{ color: '#0044F0', fontWeight: 600, display: 'flex', alignItems: 'center' }}>Aa</span>
                <button
                  onClick={() => resizeFont('decrease')}
                  className="decrease px-2 py-0.5 rounded-sm text-md leading-none ml-2 hover:opacity-70"
                  style={{ color: '#0044F0' }}
                >
                  -
                </button>
                <button
                  onClick={() => resizeFont('increase')}
                  className="increase px-1.5 py-0.5 rounded-sm text-md leading-none ml-2 hover:opacity-70"
                  style={{ color: '#0044F0' }}
                >
                  +
                </button>
              </StyledFontResizeWrapper>

              {/* MANAGE COLUMNS */}
              <Tooltip title={isSmallScreen ? t('Columns') : ''} placement="top-start">
                <StyledButtonWrapper className="toolboxButtonWrapper">
                  <MUIButton
                    variant="outlined"
                    aria-label="manage columns table"
                    onClick={() =>
                      setDialog(
                        <ColumnSelectionDialog
                          initGridColumnProps={gridSettings.gridColumnProps}
                          handleOk={(gridColumnProps, doRefresh) => {
                            const newGridSettings = {
                              ...gridSettings,
                              gridColumnProps,
                            };
                            handleGridSettingsChange(newGridSettings, doRefresh ? getCustomColumnsData : undefined);
                          }}
                          onClose={() => setDialog(undefined)}
                          alwaysShown={alwaysShown}
                        />,
                      )
                    }
                    startIcon={<FontAwesomeIcon icon={faTableColumns} />}
                    disableRipple
                  >
                    <span className="buttonLabel">{t('Columns')}</span>
                  </MUIButton>
                </StyledButtonWrapper>
              </Tooltip>

              {/* AGGREGATE COLUMNS */}
              {!!getCustomColumnsData && can('ACCESS_SUMMARIZED_VIEWS') && (
                <Tooltip title={isSmallScreen ? t('Aggregate') : ''} placement="top-start">
                  <StyledButtonWrapper className="toolboxButtonWrapper">
                    <MUIButton
                      variant="outlined"
                      aria-label="aggregate columns"
                      onClick={() => {
                        const forms = Object.values(formById).filter((form) =>
                          gridForms[friendlyName].many.includes(form.type),
                        );
                        /* Compute which tabs to show */
                        const tabs: aggregateColumnTabOption[] = [];
                        if (
                          (['reviewers_bids', 'submissions_bids'] as TableFriendlyName[]).includes(
                            tableSettings.friendlyName,
                          )
                        ) {
                          tabs.push('bidding');
                        } else {
                          if (forms.length > 0) {
                            tabs.push('forms');
                          }

                          tabs.push('assignments');

                          // Bidding for reviewers still not developed
                          if (
                            ![
                              'reviewers_to_reviewers',
                              'reviewer_assignments_of_reviewers',
                              'people_to_review',
                            ].includes(tableSettings.friendlyName)
                          ) {
                            tabs.push('bidding');
                          }
                        }
                        setDialog(
                          <AggregateColumnDialog
                            availableTabs={tabs}
                            onClose={() => setDialog(undefined)}
                            tableSettings={tableSettings}
                            forms={forms}
                            questions={forms
                              .map((form) =>
                                Object.values(questionById).filter((question) => question.form_id == form.id),
                              )
                              .flat()}
                            initCustomColumns={Object.values(customColumnsById).filter(
                              (customColumn) => customColumn.tableFriendlyName == friendlyName,
                            )}
                            handleOk={(customColumns) => {
                              updateCustomColumnsAction({
                                friendlyName: friendlyName,
                                customColumns,
                                onSuccess: getCustomColumnsData,
                              });
                            }}
                            roles={
                              tableSettings.model == 'App\\Models\\Submission'
                                ? Object.values(roleById).filter((role) => role.type === 'reviewer')
                                : []
                            }
                          />,
                        );
                      }}
                      startIcon={<FontAwesomeIcon icon={faDatabase} />}
                      disableRipple
                    >
                      <span className="buttonLabel">{t('Aggregate')}</span>
                    </MUIButton>
                  </StyledButtonWrapper>
                </Tooltip>
              )}

              {/* LABELS */}
              {hasLabelsColumn && (
                <Tooltip title={isSmallScreen ? t('Labels') : ''} placement="top-start">
                  <StyledButtonWrapper className="toolboxButtonWrapper">
                    <MUIButton
                      variant="outlined"
                      aria-label="add"
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) => setLabelAnchorEl(event.currentTarget)}
                      startIcon={<FontAwesomeIcon icon={faTags} />}
                      disableRipple
                    >
                      <span className="buttonLabel">{t('Labels')}</span>
                    </MUIButton>
                  </StyledButtonWrapper>
                </Tooltip>
              )}

              {/* ADVANCED FILTER */}
              {/*  
              <StyledButtonWrapper className="toolboxButtonWrapper">
                <MUIButton
                  variant="outlined"
                  aria-label="switch filters"
                  onClick={() => onSwitchFilters()}
                  startIcon={<FontAwesomeIcon icon={faFilter} />}
                  disableRipple
                >
                  <span className="buttonLabel">{t('Advanced Filter')}</span>
                </MUIButton>
              </StyledButtonWrapper>
              */}

              {/* FILTERS */}
              <StyledFontResizeWrapper
                className="flex items-center gap-x-3 toolboxButtonWrapper"
                style={{ marginLeft: '10px' }}
              >
                <div className="flex items-center" style={{ color: theme.palette.primary.main }}>
                  <FontAwesomeIcon icon={faFilter} size="lg" />
                  <button
                    className="flex items-center ml-1.5 gap-x-1 hover:opacity-70"
                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => setFiltersAnchorEl(event.currentTarget)}
                  >
                    <span style={{ fontSize: '15px' }}>
                      {numFilters} {numFilters == 1 ? t('filter') : t('filters')}
                    </span>
                    <ChevronDownIcon />
                  </button>
                </div>
                <div style={{ color: theme.palette.primary.main }}>
                  <button
                    className="flex items-center cursor-pointer hover:opacity-70"
                    onClick={() => setShowFilters(!showFilters)}
                  >
                    {showFilters ? <HiddenIcon width="17" /> : <ViewNewIcon width="17" />}
                    <p className="ml-1 text-xs">{showFilters ? t('Hide') : t('Show')}</p>
                  </button>
                </div>
              </StyledFontResizeWrapper>

              {/* EXPORT BIDS */}
              {['reviewers_bids', 'submissions_bids'].includes(friendlyName) && (
                <Tooltip title={isSmallScreen ? t('Export') : ''} placement="top-start">
                  <StyledButtonWrapper className="toolboxButtonWrapper">
                    <MUIButton
                      variant="outlined"
                      aria-label="export bids"
                      onClick={() => {
                        downloadFile(getHref('/web/bids/export'));
                      }}
                      startIcon={<Download2 />}
                      className="exportButton"
                    >
                      <span className="buttonLabel">{t('Export')}</span>
                    </MUIButton>
                  </StyledButtonWrapper>
                </Tooltip>
              )}

              {/* EXPORT TO EXCEL (Submissions to review) */}
              {friendlyName == 'submissions_to_review' && (
                <Tooltip title={isSmallScreen ? t('Export to Excel') : ''} placement="top-start">
                  <StyledButtonWrapper className="toolboxButtonWrapper">
                    <MUIButton
                      variant="outlined"
                      aria-label="export to excel"
                      onClick={() => setDialog(getExportDialog())}
                      startIcon={<Download2 />}
                      className="exportButton"
                    >
                      <span className="buttonLabel">{t('Export to Excel')}</span>
                    </MUIButton>
                  </StyledButtonWrapper>
                </Tooltip>
              )}

              {/* NOTIFY ALL */}
              {['reviewer_assignments', 'submission_assignments', 'reviewer_assignments_of_reviewers'].includes(
                friendlyName,
              ) &&
                Object.values(notifiableIds).filter((row) => !row.isDone).length > 0 && (
                  <Tooltip title={isSmallScreen ? t('Notify all') : ''} placement="top-start">
                    <StyledButtonWrapper className="toolboxButtonWrapper">
                      <MUIButton
                        variant="outlined"
                        aria-label="notify all"
                        onClick={() => notifyAction({})}
                        startIcon={<Email2 />}
                        disableRipple
                      >
                        <span className="buttonLabel">{t('Notify all')}</span>
                      </MUIButton>
                    </StyledButtonWrapper>
                  </Tooltip>
                )}

              {/* MESSAGE SELECTED REVIEWERS */}
              {friendlyName === 'people_to_review' && (
                <Tooltip title={isSmallScreen ? t('Email selected') : ''} placement="top-start">
                  <StyledButtonWrapper className="toolboxButtonWrapper">
                    <MUIButton
                      variant="outlined"
                      aria-label="message selected reviewers"
                      onClick={() => setDialog(getSendEmailDialog('send-email:people_role', selectedRows))}
                      startIcon={<Email2 />}
                      disableRipple
                      disabled={selectedRowIds.length === 0}
                    >
                      <span className="buttonLabel">{t('Email selected')}</span>
                    </MUIButton>
                  </StyledButtonWrapper>
                </Tooltip>
              )}
            </StyledTools>

            {bulkActionsForTable.length > 0 && (
              <StyledActions className="flex items-center justify-end moreVerticalWrapper">
                <div className="bulk-actions ml-2.5">
                  <ActionsKmenu
                    actions={bulkActionsForTable}
                    onSelect={(event) => {
                      if (!event.item.data) return;
                      const action = bulkActionsForTable.find((x) => x.id == event.item.data.id);
                      if (action && action.callback) {
                        action.callback();
                      }
                    }}
                  />
                </div>
              </StyledActions>
            )}
          </div>

          <div className="h-full gridWrapper">
            <MyGridCore
              allGridData={allGridData}
              gridSettings={{
                /* Here we decide if the column must be rendered with a custom components.*/
                ...gridSettings,
                gridColumnProps: gridSettings.gridColumnProps.map((props) => {
                  return {
                    ...props,
                    cell: props.id && !props.children ? getCustomCell(props.id) : undefined,
                    filterCell: getCustomFilterCell(props),
                    title: getTableColumnName(props.id as TableColumnId, t) ?? props.title,
                    children: props.children
                      ? props.children.map((childProps: GridColumnProps) => ({
                          ...childProps,
                          cell: childProps.field ? getCustomCell(childProps.field) : undefined,
                        }))
                      : undefined,
                  };
                }),
              }}
              onGridSettingsChange={handleGridSettingsChange}
              dataStateValue={dataState}
              filterBoxValue={filterBox}
              selectedState={selectedState}
              handleSelectRow={handleSelectRow}
              onDataStateChange={(dataState) =>
                setGridSettingsAction({ gridSettings: { ...gridSettings, dataState }, friendlyName })
              }
              onFilterBoxChange={(filterBox: FilterBox) => filterBoxChangeAction({ friendlyName, filterBox })}
              dateFormat={dateFormat}
              detail={detail}
              selectable={selectable ?? true}
              scrollToSelectedRow={
                initialSelectedRowIds[friendlyName].length > 0 ? initialSelectedRowIds[friendlyName][0] : undefined
              }
              showActionsColumn={allGridData.filter((row) => row['row_actions'] != undefined).length > 0}
              showFilters={showFilters}
              columnsAlwaysShown={alwaysShown}
              filteredIds={filteredIds[filteredIdsKey]}
              onFilteredIds={(ids) => updateFilteredIdsAction({ ids, key: filteredIdsKey })}
              externalChangeCount={tableSettings.externalChangeCount}
              exportDTO={exportDTO}
            />
          </div>
        </div>

        {labelDialog}
        {dialog}
        {popLabel}
        {/* Filters popover */}
        <Popover
          open={Boolean(filtersAnchorEl)}
          anchorEl={filtersAnchorEl}
          onClose={handleFiltersPopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <StyledPopoverContent>
            <FiltersManager
              filters={(dataState.filter?.filters ?? []) as FilterDescriptor[]}
              gridColumnProps={gridSettings.gridColumnProps}
              onClearAll={() => {
                // Get the current take value in use
                const { take, sort } = dataState;
                /**
                 * Set filter values to its default state.
                 * To clear filters of Kendo Grid means to remove filter property from the state of the grid aka dataState.
                 * https://www.telerik.com/kendo-react-ui/components/dataquery/api/process/
                 */
                const newDataState = { ...getInitialDataState(), take, sort };
                handleGridSettingsChange({ ...gridSettings, dataState: newDataState });
                handleFiltersPopoverClose();
              }}
              onSave={(filters) => {
                handleGridSettingsChange({
                  ...gridSettings,
                  dataState: { ...gridSettings.dataState, filter: { logic: 'and', filters } },
                });
                handleFiltersPopoverClose();
              }}
            />
          </StyledPopoverContent>
        </Popover>
      </ThemeProvider>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  tablesSettings: selectTable(state).tablesSettings,
  otherTablesSettings: selectTable(state).otherTablesSettings,
  currentTrack: selectCurrentTrack(state),
  labelsById: selectLabelState(state).labelsById,
  labelables: selectLabelState(state).labelables,
  questionById: selectFormState(state).questionById,
  answerById: selectFormState(state).answerById,
  formById: selectFormState(state).formById,
  dateFormat: selectCurrentUser(state).person.date_format,
  action: selectTable(state).action,
  keywordById: selectKeywordState(state).keywordById,
  customColumnsData: selectTable(state).customColumnsData,
  customColumnsById: selectTable(state).customColumnsById,
  initialSelectedRowIds: selectTable(state).selectedRowIds,
  notifiableIds: selectTable(state).notifiableIds,
  roleById: selectTrackRoles(state),
  gridForms: selectTable(state).gridForms,
  filteredIds: selectTable(state).filteredIds,
  currentRole: selectCurrentRole(state),
  user: selectCurrentUser(state),
  keywordsLevels: selectKeywordsLevels(state),
  screenByName: selectScreenState(state).screenByName,
  emailRoleIds: selectRoleRelations(state, 'send-email'),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setGridSettingsAction: (data: TablePatchSettingsDTO) => dispatch(tableSlice.actions['SETTINGS:PATCH'](data)),
  saveSettingsAction: (friendlyName: TableFriendlyName) =>
    dispatch(tableSlice.actions['SETTINGS:SAVE']({ friendlyName })),
  saveAsSettingsAction: (data: TableSaveAsSettingsDTO) => dispatch(tableSlice.actions['SETTINGS:SAVE_AS'](data)),
  loadSettingsAction: (data: LoadSettingsDTO) => dispatch(tableSlice.actions['SETTINGS:LOAD'](data)),
  deleteSettingsAction: (data: TableDeleteSettingsDTO) => dispatch(tableSlice.actions['SETTINGS:DELETE'](data)),
  pickLabelAction: (labelsByRowId: { [key: number]: number[] }, tableFriendlyName: TableFriendlyName) =>
    dispatch(labelSlice.actions['LABEL:PICK']({ labelsByRowId, tableFriendlyName })),
  unpickLabelAction: (recordId: number, labelId: number, tableFriendlyName: TableFriendlyName) =>
    dispatch(labelSlice.actions['LABEL:UNPICK']({ recordId, labelId, tableFriendlyName })),
  createLabelAction: (
    data: LabelDialogFields,
    tableFriendlyName: TableFriendlyName,
    currentTrackId: number,
    rowIds?: number[],
  ) => dispatch(labelSlice.actions['LABEL:CREATE']({ data, tableFriendlyName, currentTrackId, rowIds })),
  updateLabelAction: (labelId: number, data: LabelDialogFields) =>
    dispatch(labelSlice.actions['LABEL:UPDATE']({ labelId, data })),
  deleteLabelAction: (labelId: number, tableFriendlyName: TableFriendlyName) =>
    dispatch(labelSlice.actions['LABEL:DELETE']({ labelId, tableFriendlyName })),
  openSnackBarAction: (data: OpenSnackBarDTO) => dispatch(errorSlice.actions['OPEN:SNACKBAR'](data)),
  filterBoxChangeAction: (data: TableFilterBoxChangeDTO) => dispatch(tableSlice.actions['FILTERBOX:CHANGE'](data)),
  switchFilterAction: (data: TableSwitchFilterDTO) => dispatch(tableSlice.actions.SWITCH_FILTER(data)),
  impersonateAction: (data: ImpersonateRequest) => dispatch(authSlice.actions.IMPERSONATE(data)),
  updateUserRolesBulkAction: (data: updateUserRolesBulkDTO) =>
    dispatch(infoSlice.actions['USER:UPDATE:ROLES:BULK'](data)),
  clearValidationErrorsAction: () => dispatch(errorSlice.actions['CLEAR:VALIDATION_ERRORS']()),
  deleteInvitationsAction: (ids: number[]) => dispatch(recruitmentSlice.actions['DELETE_INVITATIONS'](ids)),
  clearSelectionAction: () => dispatch(tableSlice.actions['SELECTION:CLEAR']()),
  respondInvitationAction: (data: RespondInvitationDTO) => dispatch(recruitmentSlice.actions.RESPOND_INVITATION(data)),
  setTableAction: (actionOpt: actionOption) => dispatch(tableSlice.actions['ACTION:SET'](actionOpt)),
  updateSelectionAction: (rowIds: number[], tableFriendlyName: TableFriendlyName) =>
    dispatch(tableSlice.actions['SELECTION:UPDATE']({ rowIds, tableFriendlyName })),
  updateCustomColumnsAction: (data: CustomColumnsUpdate) => dispatch(tableSlice.actions['CUSTOMCOLUMNS:UPDATE'](data)),
  notifyAction: (data: NotifyDTO) => dispatch(tableSlice.actions['NOTIFIABLES:NOTIFY'](data)),
  deleteAssignmentAction: (data: DeleteAssignment) => dispatch(assignmentSlice.actions['ASSIGNMENTS:DELETE'](data)),
  updateFilteredIdsAction: (data: FilteredIdsUpdateDTO) => dispatch(tableSlice.actions['FILTERED_IDS:UPDATE'](data)),
  resetExternalChangeCountAction: (data: TableFriendlyName) =>
    dispatch(tableSlice.actions['EXTERNAL_CHANGE_COUNT:RESET'](data)),
});

const StyledTools = styled.div`
  padding: 7px 0;
  border-radius: 5px;

  .k-link {
    border: none;
  }

  .tool-box {
    background-color: ${(props) => props.theme.palette.primary.main};
  }

  .sync-table:hover,
  .manage-columns:hover,
  .aggregate-columns:hover,
  .labels:hover,
  .reset-filters:hover {
    .MuiIconButton-root {
      background-color: transparent; /* rgba(0, 0, 0, 0.04) */
    }
    opacity: 0.7;
  }
`;

const StyledActions = styled.div`
  background-color: #edf3ff;

  .k-link {
    color: ${(props) => props.theme.palette.primary.main};
    border-radius: 4px;
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.palette.primary.main};

    .k-icon {
      color: ${(props) => props.theme.palette.primary.main};
    }
  }

  .k-menu-link {
    padding: 4px 3px;
  }
`;

const StyledKmenu = styled(Kmenu)`
  margin-left: 1rem;
  .k-link {
    color: ${(props) => props.theme.palette.text.secondary};
    border-radius: 4px;
    background-color: ${(props) => props.theme.palette.background.paper};
    border: 1px solid ${(props) => props.theme.palette.text.secondary};
    min-width: 6.3rem;

    .k-icon {
      color: ${(props) => props.theme.palette.text.secondary};
    }
  }
`;

const StyledButtonWrapper = styled.div<{ marginLeft?: string }>`
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '10px')};

  button {
    border-color: ${(props) => props.theme.palette.primary.main};
    color: ${(props) => props.theme.palette.primary.main};
    height: 42px;

    span {
      font-weight: normal;
      text-transform: none;
    }
  }

  button:hover {
    opacity: 0.7;
    background-color: transparent;
  }

  .MuiButton-outlined.Mui-disabled {
    border-color: ${(props) => props.theme.palette.primary.main};
  }
  .MuiButton-root.Mui-disabled {
    color: ${(props) => props.theme.palette.primary.main};
  }
  .MuiButton-outlined.Mui-disabled,
  .MuiButton-root.Mui-disabled {
    opacity: 0.26;
  }
`;

const StyledFontResizeWrapper = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.23);
  padding: 5px 10px;
  border-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 3px;

  span {
    font-size: 16px;
  }

  button {
    font-size: 37px;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 0.8;
  }

  .decrease {
    font-size: 37px;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 0.8;
  }

  .increase {
    font-size: 22px;
    margin-left: 0;
  }
`;

const StyledPopoverContent = styled.div`
  width: max-content;
  max-width: 400px;
  overflow: auto;
  max-height: 600px;
  margin: 10px;
  padding: 4px;
  font-size: 0.875rem;
`;

export default connect(mapStateToProps, mapDispatchToProps)(MyGridRedux);
